module.exports = __webpack_public_path__ + "img/agenda.1f4179d5.svg";